<template>
  <div class="review-log-detail">
    <template v-if="structured">
      <dl>
        <dt>Invoice</dt><dd>{{ data.invoiceId }}</dd>
        <dt>Transaction</dt><dd>{{ data.transNo || '—' }}</dd>
        <dt>{{ t('client') }}</dt><dd>{{ data.clientCode }}</dd>
        <dt>{{ t('week') }}</dt><dd>{{ data.billingWeekStart }}</dd>
        <dt>{{ t('source') }}</dt><dd>{{ data.source }}</dd>
        <dt>{{ t('reason') }}</dt><dd class="reason">{{ data.reason || '—' }}</dd>
      </dl>
      <div class="snapshots">
        <section><strong>{{ t('before') }}</strong><pre>{{ json(data.before) }}</pre></section>
        <section><strong>{{ t('after') }}</strong><pre>{{ json(data.after) }}</pre></section>
      </div>
    </template>
    <pre v-else>{{ json(data) }}</pre>
  </div>
</template>

<script>
import { decimal, parseLog } from './utils';

const decimalFields = ['quantity', 'unitPrice', 'amountExTax', 'manualSubtotal', 'invoiceAmountExTax', 'invoiceAmount', 'gst'];

export default {
  name: 'InvoiceReviewOperationLogDetail',
  props: { content: { type: [String, Object, Array], default: '' } },
  computed: {
    data() { return parseLog(this.content); },
    structured() { return this.data && this.data.schemaVersion === 1 && this.data.invoiceId; },
  },
  methods: {
    t(key) { return this.$t(`invoiceReview.${key}`); },
    json(value) {
      if (typeof value === 'string') return value;
      return JSON.stringify(value, (key, field) => this.structured && decimalFields.includes(key) && field != null ? decimal(field) : field, 2);
    },
  },
};
</script>

<style scoped>
dl { display: grid; grid-template-columns: 100px 1fr; gap: 10px; margin: 0 0 22px; }
dt { color: #78859a; } dd { margin: 0; overflow-wrap: anywhere; }
.reason, pre { white-space: pre-wrap; overflow-wrap: anywhere; }
.snapshots { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
pre { background: #f6f8fb; padding: 14px; font-size: 12px; max-height: 350px; overflow: auto; }
</style>
